// Keep an explicit empty value: UPDATE_CHAT_LIST_FILTERS merges into old state.
export const jevFilterParams = (enabled, advancedView, signal) =>
  enabled ? { jevSignal: advancedView ? '' : signal } : {};

const filterSignature = (filters = {}) =>
  JSON.stringify([
    filters.jevSignal || '',
    filters.inboxId,
    filters.status,
    filters.assigneeType,
    filters.labels,
    filters.teamId,
    filters.conversationType,
    filters.sortBy,
  ]);

// Only pilot requests use this guard; other accounts keep their existing flow.
// Pagination is deliberately excluded so loading the next page stays valid.
export const currentJevRequest = (rootGetters, params) => {
  if (!rootGetters?.['jevSignals/enabled']) return () => true;
  const accountId = rootGetters.getCurrentAccountId;
  const signature = filterSignature(params);
  return () =>
    rootGetters['jevSignals/enabled'] &&
    rootGetters.getCurrentAccountId === accountId &&
    filterSignature(rootGetters.getChatListFilters) === signature;
};
